<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="order-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="discount-detail">
                        <div class="order-time">下单时间：{{ payTime }}</div>
                        <ul v-if="player_list.length">
                            <li class="clearfix" v-for="(player,index) in player_list" :key="index">
                                <div class="player-name f-l">
                                    {{ player.name.replace(/\x7F+/g,"")}}
                                </div>
                                <div class="cnt f-r">
                                    帮砍
                                    <em class="icon-m3b"></em>
                                    {{ player.discount }}
                                </div>
                            </li>
                        </ul>
                        <ul v-else>
                            <li>
                                <div class="player-name f-l">
                                    无人砍价
                                </div>                                
                            </li>
                        </ul>                
                    </div>

                    <div class="u-btn ok" @click="destroyElement()"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
    .order-modal{
        position: relative;
        width: 625px;
        height: 365px;
        background-image: url(~@/assets/images/modal/bg-modal-order.png);        
    }

    .title{
        width: 512px;
        height: 52px;
        margin: 0 auto 36px;
        background-image: url(~@/assets/images/modal/title-orderdetail.png);      
    }

    .order-time{
        text-align: center;
        margin-bottom: 16px;
    }

    .discount-detail ul{
        width: 541px;
        margin: 0 auto;
        background-color: #f8f7f3;
        border: 1px solid #f2f0e9;        

        li{
            display: flex;
            justify-content: space-between;
            padding: 12px 12px;
        }
    }

    .notice{
        .empty-img{
            width: 273px;
            height: 249px;
            margin: -20px auto 0;
            background-image: url(~@/assets/images/modal/order-none.png); 
        }
    }

    .u-btn.ok{
        position: absolute;
        left: 50%;
        bottom: 34px;
        transform: translateX(-50%);
        width: 186px;
        height: 56px;
        background-image: url(~@/assets/images/modal/btn-close-modal.png);
    }      

</style>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            iscopy : false,
            text : '请稍后……',
            shareTxt : '分享专属链接 开启助力',
            gid : '',
            mode : 1,
            ajax_error : false,  
            player_list: [],
            payTime : '',         
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              //_this.$error_modal({text : "复制成功"});
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
              //_this.$error_modal({text : "复制失败"});
            });
        },             
    },
}
</script>